import { ArrowUpRight, MessageCircle } from 'lucide-react'
import { ButtonLink, type ButtonVariant } from '@/components/play'

/** Our community and support server, also linked from the watch-along guide's notes. */
export const discordSupportUrl = 'https://discord.gg/UvWY2VMTEJ'

/** Secondary on light surfaces; pass `inverse` on dark photography, where the pale secondary fill turns muddy. Its
 *  visible words and the screen-reader text name it, so it has no native `title`: that would repeat them in a browser
 *  tooltip rather than a Play one. */
export function DiscordSupportLink({ variant = 'secondary' }: { variant?: ButtonVariant }) {
  return (
    <ButtonLink
      variant={variant}
      href={discordSupportUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <MessageCircle aria-hidden="true" />
      Join our Discord
      <ArrowUpRight aria-hidden="true" />
      <span className="sr-only"> for support (opens in a new tab)</span>
    </ButtonLink>
  )
}
